import { clsx } from '../functions'
import './tacho.css';
import './statistics.css';
import ModalInfoEffizienzklasse from "../modals/modal_info_energieeffizienzklasse.tsx";
import InfoButton from "./inputs/info-button.tsx";

export default function Tacho(props:{label: string, now: number, future?:number}) {
  const max = 300;
  const percent_now = (Math.min(max, Math.max(0, props.now)) / max) * 100;
  const percent_future = (Math.min(max, Math.max(0, props.future ?? 0)) / max) * 100;
  const has_future = props.future !== null && props.future !== 0 && props.future !== "";

  return (
     <div 
      className='statistics statistics-efz'    
      style={{paddingTop: "4rem"}} 
      aria-live="polite"
      aria-label={props.label}
      aria-description={
          `Aktueller Wert: ${props.now?.toLocaleString() + " kWh/m²a" || "nicht definiert"} (Klasse: ${kwh_to_class(props.now)}), Wert nach Sanierung: ${props.future ? props.future.toLocaleString() + " kWh/m²a" : "nicht definiert"} (Klasse: ${kwh_to_class(props.future)})`
      }
     >
      {/* <div className='statistics__label' style={{display: "flex"}}>{props.label} 
        <span style={{display: "inline-block", width: "0.2rem"}}></span> <InfoButton modal={<ModalInfoEffizienzklasse/>}/>
        <div className={clsx('statistics__info-now', !has_future && 'statistics__info-now--single')}>{props.now}</div>
        {
          has_future && <>
            <div className='statistics__info-triangle'></div>
            <div className='statistics__info-future'>{props.future}</div>
          </>   
        }
        <div className='statistics__info-unit'>kWh/m²a</div>
      </div> */}
      <div className='tacho' aria-hidden>
        <div className="tacho__element-container">
          <div className='tacho__element'>A+</div>
          <div className="tacho__value">30</div>
        </div>
        <div className="tacho__element-container">
          <div className='tacho__element'>A</div>
          <div className="tacho__value">50</div>
        </div>
        <div className="tacho__element-container">
          <div className='tacho__element'>B</div>
          <div className="tacho__value">75</div>
        </div>
        <div className="tacho__element-container">
          <div className='tacho__element'>C</div>
          <div className="tacho__value">100</div>
        </div>
        <div className="tacho__element-container">
          <div className='tacho__element'>D</div>
          <div className="tacho__value">130</div>
        </div>
        <div className="tacho__element-container">
          <div className='tacho__element'>E</div>
          <div className="tacho__value">160</div>
        </div>
        <div className="tacho__element-container">
          <div className='tacho__element'>F</div>
          <div className="tacho__value">200</div>
        </div>
        <div className="tacho__element-container">
          <div className='tacho__element'>G</div>
          <div className="tacho__value">250</div>
        </div>
        <div className="tacho__element-container">
          <div className='tacho__element'>H</div>
          <div className="tacho__value">300</div>
        </div>
        <div className={clsx('tacho__pointer-now', 'tacho__pointer--offset', !has_future && 'tacho__pointer-now--single')} style={{left: percent_now+"%"}}>
          <div className="tacho__pointer-label">
            Bisher {props.now} kWh/m²a
          </div>
        </div>
        {
          has_future && <div className='tacho__pointer-future' style={{left: percent_future+"%"}}>
             <div className="tacho__pointer-label">
                Geplant {props.future} kWh/m²a
            </div>
          </div>
        }
      </div>
     </div>
  )
}

function kwh_to_class(kwh: number) : "A+" | "A" | "B" | "C" | "D" | "E" | "F" | "G" | "H" {
   if (kwh < 30) return "A+";
   if (kwh < 50) return "A";
   if (kwh < 75) return "B";
   if (kwh < 100) return "C";
   if (kwh < 130) return "D";
   if (kwh < 160) return "E";
   if (kwh < 200) return "F";
   if (kwh < 250) return "G";
   if (kwh < 300) return "H";
}